import { createSelector } from 'reselect'

import { getDataState } from '../selectors'
import { DashboardDataState } from '../types'
import { IdIndexedInvestorChecks, INVESTOR_CHECKS_STORE_ID, InvestorCheck } from './types'

const getInvestorChecksState = createSelector(getDataState, (dataState) => dataState[INVESTOR_CHECKS_STORE_ID])

export const getAllInvestorChecks = createSelector(
  getInvestorChecksState,
  (investorChecksState) => investorChecksState.items
)

export const getIsFetchingInvestorChecks = createSelector(
  getInvestorChecksState,
  (investorChecksState) => investorChecksState.isFetching || investorChecksState.isFetchingAvailableChecks
)

export const getAvailableChecks = createSelector(getInvestorChecksState, ({ availableChecks }) => availableChecks)

export const getNonDeprecatedChecks = createSelector(getAvailableChecks, (checksConfig) =>
  checksConfig.filter(({ deprecated }) => !deprecated)
)

export function getInvestorCheck({ investorChecks }: DashboardDataState, investorCheckId: InvestorCheck['id']) {
  return investorChecks.items[investorCheckId] as InvestorCheck
}

export const getInvestorChecksData = createSelector(getAllInvestorChecks, (allInvestorChecks) => {
  return Object.keys(allInvestorChecks).reduce((result, investorId) => {
    const investorCheck = allInvestorChecks[investorId]
    result.push(investorCheck)
    return result
  }, [] as InvestorCheck[])
})

export function countInvestorChecks(investorChecks: IdIndexedInvestorChecks) {
  return Object.keys(investorChecks).length
}
